<template>
  <button @click="exportTransaction" class="btn btn-info is-border-1 mr-1 mb-2">
    <i class="fa fa-download"></i>
    {{ $t('export') }}
    <b-modal v-model="exporting" :title="$t('exportingData')" @close="close" no-close-on-esc no-close-on-backdrop
             no-enforce-focus>
      <b-progress :max="totalCount">
        <b-progress-bar :value="downloadedCount"
                        :label="`${((downloadedCount / totalCount) * 100).toFixed(0)}%`"></b-progress-bar>
      </b-progress>
    </b-modal>
  </button>
</template>


<script>
import {saveAs} from 'file-saver';
import Excel from 'exceljs';
import moment from 'moment';

export default {
  name: "CallHistoryExport",
  props: ['filter', 'totalCount'],
  data() {
    return {
      exporting: false,
      cancelRequest: false,
      downloadedCount: 0
    }
  },
  methods: {
    exportTransaction: async function () {
      this.downloadedCount = 0;
      this.exporting = true;
      let workbook = new Excel.Workbook();
      let sheet = workbook.addWorksheet('data');
      this.setupSheet(sheet);

      let response = null;
      let params = Object.assign({}, this.filter);
      params.page = 1;
      params.pageSize = 500;
      do {
        if (this.cancelRequest) {
          break;
        }
        let result = await this.$service.get('/sms', {
          params: params
        });
        params.page += 1;
        response = result.data;
        response.docs.forEach(item => {
          let row = {
            client: item.client.domain,
            fromUser: item.user && item.user.name ? item.user.name : '',
            brandName: item.brandName ? item.brandName.name : '',
            type: this.$t(item.type),
            number: item.number,
            createTime: moment(item.createTime).format('DD/MM/YYYY HH:mm:ss'),
            sendTime: item.sendTime ? moment(item.sendTime).format('DD/MM/YYYY HH:mm:ss') : '',
            chargeTime: item.chargeTime ? moment(item.chargeTime).format('DD/MM/YYYY HH:mm:ss') : '',
            chargedFee: item.chargedFee ? item.chargedFee : 0,
            numberOfSms: item.numberOfSms ? item.numberOfSms : 0,
            content: item.content,
            status: item.sendError ? this.$t('error') : this.$t('success'),
            sendErrorMsg: item.sendErrorMsg,
          }
          sheet.addRow(row);
          this.downloadedCount += 1;
        });
      } while (response && response.hasNextPage);

      workbook.xlsx.writeBuffer({base64: true}).then(data => {
        this.exporting = false;
        saveAs(new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
            'sms-history.xlsx');
      }).finally(() => {
        this.cancelRequest = false;
        this.downloadedCount = 0;
      });
    },
    setupSheet: function (sheet) {
      sheet.columns = [
        {header: this.$t('client'), key: 'client', width: 15},
        {header: this.$t('fromUser'), key: 'fromUser', width: 15},
        {header: 'Brand name', key: 'brandName', width: 15},
        {header: this.$t('type'), key: 'type', width: 15},
        {header: this.$t('number'), key: 'number', width: 15},
        {header: this.$t('createTime'), key: 'createTime', width: 15},
        {header: this.$t('sendTime'), key: 'sendTime', width: 15},
        {header: this.$t('chargeTime'), key: 'chargeTime', width: 15},
        {header: this.$t('chargedFee'), key: 'chargedFee', width: 15},
        {header: this.$t('numberOfSms'), key: 'numberOfSms', width: 15},
        {header: this.$t('content'), key: 'content', width: 50},
        {header: this.$t('status'), key: 'status', width: 15},
        {header: this.$t('sendErrorMsg'), key: 'sendErrorMsg', width: 15},
      ];
    },
    close() {
      this.cancelRequest = true;
    }
  },
  i18n: {
    messages: {
      en: {
        fromUser: "Send from",
        number: "Phone number",
        content: "Content",
        chargeTime: 'Charge time',
        chargedFee: 'Charged fee',
        numberOfSms: 'Number of SMS',
      },
      vi: {
        fromUser: "Gửi từ",
        number: "Số điện thoại",
        content: "Nội dung",
        chargeTime: 'Tính tiền lúc',
        chargedFee: 'Số tiền',
        numberOfSms: 'Tổng tin gửi',
      }
    }
  }
}
</script>